import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import type { FlashType } from 'modules/core/store/models/app'
import app from 'modules/core/store/models/app'

import type { Action, State } from 'modules/api_public/components/ApiKeySettings/Table/types'
import { useApiKeys } from 'modules/api_public/store/collections/apiKeys'

interface Props {
  dispatch: React.Dispatch<Action>
  state: State
}

const DeleteModal = ({ dispatch, state }: Props) => {
  const apiKeys = useApiKeys()

  const showFlashMessage = (type: FlashType, message: string) => {
    app.setFlash({
      type,
      message,
    })
  }

  const deleteKey = async () => {
    try {
      const apiKey = apiKeys.find({ id: state.key })
      if (!apiKey) {
        return
      }

      await asyncAction(() => apiKey.destroy(), {
        successMessage: i18n.t('settings.api_keys.confirm_delete.deleted'),
        errorMessage: i18n.t('settings.api_keys.confirm_delete.error'),
      })
    } finally {
      dispatch({ type: 'closeModals' })
    }
  }

  return (
    <Modal
      title={i18n.t('settings.api_keys.confirm_delete.title')}
      description={i18n.t('settings.api_keys.confirm_delete.description')}
      illustration="delete"
      onClose={() => dispatch({ type: 'closeModals' })}
      onSubmit={deleteKey}
      footer={
        <Button type="negative" submit>
          {i18n.t('settings.api_keys.delete_key')}
        </Button>
      }
    />
  )
}

export default DeleteModal
